import React, { FC, ReactNode } from "react";
import { StyledErrorMessage } from "./style";

interface ErrorMessageProps {
    width?: string;
    children: ReactNode;
}

const ErrorMessage: FC<ErrorMessageProps> = ({children, width}) => {

    return(
        <StyledErrorMessage width={width}>
            {children}
        </StyledErrorMessage>
    )
}

export default ErrorMessage;